/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Posts_CreatedInputs */

const en_admin_posts_created = /** @type {(inputs: Admin_Posts_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Post created`)
};

/**
* | output |
* | --- |
* | "Post created" |
*
* @param {Admin_Posts_CreatedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_posts_created = /** @type {((inputs?: Admin_Posts_CreatedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Posts_CreatedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_posts_created(inputs)
});
export { admin_posts_created as "admin.posts.created" }